import { all, call, put, select, take, takeLatest } from 'redux-saga/effects';

import { SELECT_DEALER } from 'constants/ActionTypes';
import { PATH } from 'constants/RoutesConstants';
import { scopeToPage } from 'modules/app/sagas/utils';
import { simpleRequestsLoader } from 'modules/app/utils';
import type { MayBe } from 'modules/global/typing/common/common';
import { FETCH_GROUP_FAILURE, FETCH_GROUP_SUCCESS, SELECT_GROUP } from 'modules/groups/actionTypes';
import { getSelectedGroupId } from 'modules/groups/selectors';
import { fetchMessagingAccount, fetchMessagingAccounts } from 'modules/messagingAccounts/actions';
import * as types from 'modules/messagingAccounts/actionTypes';
import { DASHBOARD_SOURCE, MODAL_SOURCE } from 'modules/messagingAccounts/constants';
import requestsConfig from 'modules/messagingAccounts/requestsConfig';
import { getBaseRequestParams } from 'modules/messagingAccounts/selectors/dashboard';
import type { FetchMessagingAccountsParams, OpenMessagingAccountModalAction } from 'modules/messagingAccounts/types';

const DASHBOARD_REFRESH_ACTIONS = [
  types.SET_DASHBOARD_FILTER,
  types.CLEAR_DASHBOARD_FILTERS,
  types.CREATE_MESSAGING_ACCOUNT_SUCCESS,
  types.UPDATE_MESSAGING_ACCOUNT_SUCCESS,
];

export function* refreshDashboard() {
  const params: FetchMessagingAccountsParams = yield select(getBaseRequestParams);
  yield put(fetchMessagingAccounts(params, { source: DASHBOARD_SOURCE }));
}

export function* fetchModalAccount({ payload: accountId }: OpenMessagingAccountModalAction) {
  if (accountId) {
    yield put(fetchMessagingAccount(accountId, { source: MODAL_SOURCE }));
  }
}

export function* onGroupDashboardWorker() {
  const groupId: MayBe<string> = yield select(getSelectedGroupId);
  if (!groupId) {
    yield take([FETCH_GROUP_SUCCESS, FETCH_GROUP_FAILURE]);
  }

  yield call(refreshDashboard);
  yield takeLatest([SELECT_GROUP, ...DASHBOARD_REFRESH_ACTIONS], refreshDashboard);
  yield takeLatest(types.OPEN_MODAL, fetchModalAccount);
}

export function* onDealerDashboardWorker() {
  yield call(refreshDashboard);
  yield takeLatest([SELECT_DEALER, ...DASHBOARD_REFRESH_ACTIONS], refreshDashboard);
  yield takeLatest(types.OPEN_MODAL, fetchModalAccount);
}

export default function* messagingAccountsSaga() {
  yield scopeToPage([PATH.GROUP_SMS_ACCOUNTS_DASHBOARD], onGroupDashboardWorker);
  yield scopeToPage([PATH.DEALER_SMS_ACCOUNTS_DASHBOARD], onDealerDashboardWorker);
  yield all(simpleRequestsLoader(requestsConfig));
}
